import { render, staticRenderFns } from "./FeeListForm.vue?vue&type=template&id=4dd6131b&"
import script from "./FeeListForm.vue?vue&type=script&lang=js&"
export * from "./FeeListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports